import React from 'react';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

interface OrdersLoadMoreProps {
  shown: number;
  total: number;
  onLoadMore: () => void;
}

/**
 * „Załaduj więcej” under the customer and supplier order lists (useLoadMore).
 * Styled by `.orders-load-more` in pages/Orders.css, which hosts both lists.
 */
const OrdersLoadMore: React.FC<OrdersLoadMoreProps> = ({ shown, total, onLoadMore }) => {
  const { t } = useTranslation('orders');

  if (shown >= total) return null;

  return (
    <div className="orders-load-more">
      <Button onClick={onLoadMore}>{t('orders:loadMore.button')}</Button>
      <Typography.Text type="secondary">
        {t('orders:loadMore.shownOf', { shown, total })}
      </Typography.Text>
    </div>
  );
};

export default OrdersLoadMore;
